import React from "react"
import Link from "gatsby-link"
import cx from "classnames"

type Props = {
  className?: string
  children: string
  type: "primary" | "secondary" | "tertiary" | "text" | "yellow"
  to: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

function LinkButton(props: Props) {
  const { children, className, type, onClick } = props

  return (
    <Link
      onClick={e => {
        if (onClick) onClick(e)
      }}
      to={props.to}
      className={cx(
        "block",
        "px-3",
        "xs:px-6",
        "py-3",
        "rounded-xl",
        "font-bold",
        "text-center",
        "transform duration-300 transition",
        {
          border: type !== "text",
        },
        {
          underline: type === "text",
        },
        {
          "text-white": type === "primary" || type === "secondary",
          "text-black": type === "tertiary" || type === "yellow",
        },
        {
          "border-purple": type === "primary",
          "border-black":
            type === "secondary" || type === "tertiary" || type === "yellow",
        },
        {
          "bg-purple": type === "primary",
          "bg-black": type === "secondary",
          "bg-white": type === "tertiary",
          "bg-yellow": type === "yellow",
        },
        {
          "hover:opacity-90": type === "primary",
          "hover:bg-purple hover:border-purple": type === "secondary",
          "hover:text-purple hover:border-purple": type === "tertiary",
        },
        className
      )}
    >
      {children}
    </Link>
  )
}

export default LinkButton
